import { render, staticRenderFns } from "./GenericLoader.vue?vue&type=template&id=6d0fcbbe&scoped=true"
import script from "./GenericLoader.vue?vue&type=script&lang=js"
export * from "./GenericLoader.vue?vue&type=script&lang=js"
import style0 from "./GenericLoader.vue?vue&type=style&index=0&id=6d0fcbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0fcbbe",
  null
  
)

export default component.exports